import { gettext, modals, notifications } from '@bikemap/js/services'
import { defaultPost } from '@bikemap/js/utility'

function handleDeleteConfirm(e, modal) {
    modal.setLoading()
    defaultPost(modal.referrer.dataset.href)
        .then(({ url }) => {
            if (url) {
                location.href = url
            }
        })
        .catch(res => notifications.error(res.statusText))
        .finally(() => {
            modal.setLoading(false)
            modals.close()
        })
}

export function initDeleteBtn() {
    const deleteBtn = document.getElementById('delete-button')
    deleteBtn.classList.remove('hidden')
    deleteBtn.addEventListener('click', e => {
        e.preventDefault()
        modals.show('delete-collection', {
            title: gettext('Delete route collection'),
            message: gettext('Do you really want to delete this route collection?'),
            buttons: [
                { content: gettext('Cancel'), action: 'close' },
                { content: gettext('Confirm'), style: 'danger', action: 'submit' },
            ],
            onSubmit: handleDeleteConfirm,
            referrer: deleteBtn,
        })
    })
}
